module.exports = __webpack_public_path__ + "img/toumingmochoubiandaiWu.min.3f43944f.png";